import CompetitionTable from "@/features/competitions/components/CompetitionTable";
import CompetitionUpsertDialog from "@/features/competitions/components/CompetitionUpsertDialog";
import {useMemo} from "react";
import {type Competition, type SortField, useCompetitions, useDeleteCompetition,} from "@/hooks/useCompetitions";
import HeaderTextButton from "@/components/HeaderTextButton";
import {useQueryModal} from "@/hooks/useQueryModal";
import {useTableQuery} from "@/hooks/useTableQuery.ts";

export default function AdminCompetitionsPage() {
    const {
        searchParams,
        editId,
        isNew,
        modalOpen,
        setParam,
        openCreate,
        openEdit,
        closeModal,
    } = useQueryModal();

    const {
        page,
        size,
        sortBy,
        sortOrder,
        setPage,
        onRequestSort,
    } = useTableQuery<SortField>({
        searchParams,
        setParam,
        defaultPage: 0,
        defaultSize: 10,
        defaultSortBy: "title",
        defaultSortOrder: "desc",
    });

    const {
        data: result = {page, size, total: 0, items: []} as any,
        isLoading,
        isError,
    } = useCompetitions({page, size, sortBy, sortOrder});

    const {mutateAsync: deleteCompetition} = useDeleteCompetition();

    const initialForDialog: Partial<Competition> | null = useMemo(() => {
        if (isNew) return null;
        if (editId) return result.items.find((c: Competition) => c.id === editId) ?? null;
        return null;
    }, [isNew, editId, result]);

    return (
        <>
            <HeaderTextButton
                title="Competitions"
                description="Create and manage public competitions."
                label="Create Competition"
                onClick={openCreate}
            />

            <CompetitionTable
                content={result}
                isLoading={isLoading}
                isError={isError}
                onCreate={openCreate}
                onEdit={openEdit}
                onDelete={deleteCompetition}
                setPage={setPage}
                sortBy={sortBy}
                sortOrder={sortOrder}
                onRequestSort={onRequestSort}
            />

            <CompetitionUpsertDialog open={modalOpen} initial={initialForDialog} onClose={closeModal}/>
        </>
    );
}
